import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Progress as AviaryProgress } from '@swyftx/aviary/atoms/Progress';
import { Body } from '@swyftx/aviary/atoms/Typography';
import { types } from '@swyftx/marketing-utils';

export default function Progress({ requirements = [] }: { requirements?: types.UserAssetRedemptionRequirement[] }) {
  const trueCount = requirements.filter((requirement) => {
    const threshold = requirement.thresholdAmount === null ? 1 : requirement.thresholdAmount;
    return requirement.progress === threshold;
  }).length;
  const totalCount = requirements.length;
  const value = totalCount > 0 ? (trueCount / totalCount) * 100 : 0; // Normalize as a percentage

  return (
    <FlexLayout alignItems='center' justifyContent='start' spacing={12}>
      <AviaryProgress value={value} />
      <Body weight='emphasis'>{value}%</Body>
    </FlexLayout>
  );
}
